/**
 * FleetSection - Wraps FleetBuilder with fleet data upload capabilities.
 *
 * States:
 *   idle -> FleetBuilder (with Upload button)
 *   uploading -> EVDataUploader
 *   reviewing -> FleetImportReview
 */

import React, { useState } from 'react';
import { FleetBuilder } from '../../../components/ev';
import FleetImportReview from '../../../components/ev/import/FleetImportReview';
import { EVDataUploader } from '../../../extraction/EVDataUploader';
import { useVehicleDatabase } from '../hooks/useVehicleDatabase';

function FleetSection({ fleet, onChange, projectId }) {
    const [mode, setMode] = useState('idle'); // idle | uploading | reviewing
    const [extractionResult, setExtractionResult] = useState(null);
    const { vehicles: vehicleDatabase } = useVehicleDatabase();

    const handleExtractionComplete = (result) => {
        setExtractionResult(result?.extracted_data || result);
        setMode('reviewing');
    };

    const handleImport = async (fleetEntries) => {
        // Append imported vehicles to existing fleet
        const newFleet = [...(fleet || []), ...fleetEntries];
        onChange(newFleet);
        setMode('idle');
        setExtractionResult(null);
    };

    const handleCancel = () => {
        setMode('idle');
        setExtractionResult(null);
    };

    if (mode === 'uploading') {
        return (
            <EVDataUploader
                projectId={projectId}
                onExtractionComplete={handleExtractionComplete}
            />
        );
    }

    if (mode === 'reviewing' && extractionResult) {
        return (
            <FleetImportReview
                extractionResult={extractionResult}
                vehicleDatabase={vehicleDatabase}
                onImport={handleImport}
                onCancel={handleCancel}
            />
        );
    }

    return (
        <FleetBuilder
            fleet={fleet || []}
            onChange={onChange}
            onUploadClick={() => setMode('uploading')}
        />
    );
}

export default FleetSection;
